/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentOpportunityUserFromJSON, DocumentOpportunityUserToJSON } from './DocumentOpportunityUser';
export function GetDocumentOpportunityUsersResponseDataFromJSON(json) {
    return GetDocumentOpportunityUsersResponseDataFromJSONTyped(json, false);
}
export function GetDocumentOpportunityUsersResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentOpportunityUsers: !exists(json, 'document_opportunity_users')
            ? undefined
            : json['document_opportunity_users'].map(DocumentOpportunityUserFromJSON)
    };
}
export function GetDocumentOpportunityUsersResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_opportunity_users: value.documentOpportunityUsers === undefined
            ? undefined
            : value.documentOpportunityUsers.map(DocumentOpportunityUserToJSON)
    };
}
